import gsap from "gsap";
import {ScrollTrigger}from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const setupRoadmapAnimations=({
  sectionRef,
  stageRef,
  trackRef,
  itemRefs,
  centerRef,
  roadmapItems
})=>{
  const section=sectionRef.current;
  const stage=stageRef.current;
  const track=trackRef.current;
  const center=centerRef.current;
  const items=itemRefs.current;

  if(!section||!stage||!track||!center||!items.length){
    return;
  }

  const ctx=gsap.context(()=>{

    const progressDots=section.querySelectorAll(
      ".roadmap-progress-dot"
    );

    const setActiveItem=(activeIndex)=>{
      items.forEach((item,index)=>{
        if(!item)return;

        item.classList.toggle(
          "is-active",
          index===activeIndex
        );
      });

      progressDots.forEach((dot,index)=>{
        dot.classList.toggle(
          "is-active",
          index===activeIndex
        );
      });
    };

    const getHorizontalDistance=()=>{
      return Math.max(
        0,
        track.scrollWidth-window.innerWidth
      );
    };

    const getClosestItem=()=>{
      const viewportCenter=window.innerWidth/2;

      let closestIndex=0;
      let closestDistance=Infinity;

      items.forEach((item,index)=>{
        if(!item)return;

        const rect=item.getBoundingClientRect();
        const itemCenter=rect.left+(rect.width/2);
        const distance=Math.abs(
          itemCenter-viewportCenter
        );

        if(distance<closestDistance){
          closestDistance=distance;
          closestIndex=index;
        }
      });

      return closestIndex;
    };

    const updateActiveItem=()=>{
      const activeIndex=getClosestItem();
      setActiveItem(activeIndex);
    };

    const setInitialPositions=()=>{
      gsap.set(track,{
        x:0
      });

      setActiveItem(0);
    };

    setInitialPositions();

    const horizontalTween=gsap.to(track,{
      x:()=>{
        return -getHorizontalDistance();
      },
      ease:"none",
      overwrite:"auto",
      scrollTrigger:{
        trigger:section,
        start:"top top",
        end:()=>{
          return `+=${getHorizontalDistance()}`;
        },
        scrub:1,
        pin:true,
        anticipatePin:1,
        invalidateOnRefresh:true,
        onUpdate:updateActiveItem,
        onRefresh:updateActiveItem
      }
    });

    const centerAnimation=gsap.fromTo(
      center,
      {
        opacity:0
      },
      {
        opacity:1,
        duration:0.4,
        ease:"power2.out",
        scrollTrigger:{
          trigger:section,
          start:"top top",
          end:()=>{
            return `+=${getHorizontalDistance()}`;
          },
          scrub:1,
          invalidateOnRefresh:true
        }
      }
    );

    const resizeHandler=()=>{
      ScrollTrigger.refresh();
    };

    window.addEventListener(
      "resize",
      resizeHandler
    );

    const refreshId=requestAnimationFrame(()=>{
      ScrollTrigger.refresh();
      updateActiveItem();
    });

    return()=>{
      cancelAnimationFrame(refreshId);

      window.removeEventListener(
        "resize",
        resizeHandler
      );

      horizontalTween.scrollTrigger?.kill();
      horizontalTween.kill();

      centerAnimation.scrollTrigger?.kill();
      centerAnimation.kill();
    };

  },section);

  return()=>{
    ctx.revert();
  };
};